import Modal from "react-modal";
import { useSortContext } from "../../contexts/SortProvider";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import { FormattedMessage, useIntl } from "react-intl";
import "./SortDrawer.scss";
import { Button } from "app/components/ui/Button/Button";
import { CrossIcon } from "app/icons/navigation";
import { TripAdvisor } from "app/icons/brands";
import { RadioIcon } from "app/icons/controls";
import PropTypes from "prop-types";

export const SortDrawer = ({ onChange }) => {
	const { isOpen, closeDrawer, sortBy, setSortBy, options } = useSortContext();
	const { formatMessage } = useIntl();

	const handleSortChange = optionId => {
		setSortBy(optionId);

		if (onChange) {
			onChange(optionId);
		}

		closeDrawer();
	};

	return (
		<Modal
			isOpen={isOpen}
			closeTimeoutMS={200}
			onRequestClose={closeDrawer}
			overlayClassName="sort-drawer__overlay"
			className="sort-drawer__content"
		>
			<header className="sort-drawer__header">
				<Typography
					variant={TYPOGRAPHY_VARIANTS.XL}
					component="h2"
					isBold
					className="sort-drawer__radio-label-text"
				>
					<FormattedMessage id="sort.sort.by" />
				</Typography>

				<Button
					variant="borderless"
					onClick={closeDrawer}
					size="icon-lg"
					className="sort-drawer__close-button"
					startIcon={<CrossIcon />}
				/>
			</header>

			<fieldset>
				<legend className="sr-only">
					<FormattedMessage id="sort.sort.options.screen.reader" />
				</legend>

				<ul className="sort-drawer__options">
					{options.map(option => {
						const isChecked = sortBy === option.id;
						const sortLabel = option?.label || formatMessage({ id: option.labelKey });

						return (
							<li key={option.id} className="sort-drawer__option">
								<input
									type="radio"
									id={option.id}
									name="sortBy"
									checked={sortBy === option.id}
									onChange={() => handleSortChange(option.id)}
									className="sort-drawer__radio-input sr-only"
								/>

								<label htmlFor={option.id} className="sort-drawer__radio-label">
									<span className="sort-drawer__radio-icon" aria-hidden="true">
										<RadioIcon checked={isChecked} />
									</span>

									<Typography
										variant={TYPOGRAPHY_VARIANTS.REGULAR}
										component="span"
										className="sort-drawer__radio-label-text"
									>
										{sortLabel}
									</Typography>

									{option.id === "rating_desc" && <TripAdvisor />}
								</label>
							</li>
						);
					})}
				</ul>
			</fieldset>
		</Modal>
	);
};

SortDrawer.propTypes = {
	onChange: PropTypes.func,
};
